<template>
	<dashboard-dropdown-section
		:title="getLabel('bookingRequestsSent', 'Booking Requests Sent')"
		type="practice-requests-sent"
		:items-shown="5"
		:items="offers"
		event-name="load-practice-requests"
		@load-practice-requests="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';

import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'PracticeRequestsSent',

	components: {
		DashboardDropdownSection,
	},

	data: () => ({
		offers: [],
	}),

	methods: {
		...mapActions('offers', ['FetchFilteredOffers']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const offersResults = await this.FetchFilteredOffers({ startDate, endDate, offersType: 'practice-booking-requests-sent' });
			this.offers = offersResults.map(set => ({ ...set, event_start_date: set.offer ? set.offer.date : set.availability.date }));
		},
	},
};
</script>
